package music.jammers.client.shared.event.track.presentation.viewmodel

import music.jammers.client.shared.event.track.presentation.model.UpdateInstrument

data class AddEventTrackState(
    val eventId: Long = -1,
    val progress: Boolean = true,
    val artistName: String = "",
    val trackTitle: String = "",
    val comment: String = "",
    val addButtonEnabled: Boolean = false,
    val selectedInstruments: List<UpdateInstrument> = emptyList(),
    val error: Throwable? = null,
)